export const FEATURE_CONSTANT = {
  MANUALLY_CREATED_METAL_TAG_TEXT: '手動入力',
}
